/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DocumentoAccasamentoUpdateDTO
 */
export interface DocumentoAccasamentoUpdateDTO {
    /**
     * 
     * @type {number}
     * @memberof DocumentoAccasamentoUpdateDTO
     */
    idAnagrafeMittente?: number;
    /**
     * 
     * @type {number}
     * @memberof DocumentoAccasamentoUpdateDTO
     */
    idAnagrafeDestinatario?: number;
    /**
     * 
     * @type {Date}
     * @memberof DocumentoAccasamentoUpdateDTO
     */
    dataDocumento?: Date;
    /**
     * 
     * @type {string}
     * @memberof DocumentoAccasamentoUpdateDTO
     */
    numeroDocumento?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof DocumentoAccasamentoUpdateDTO
     */
    dataOperazione?: Date;
    /**
     * 
     * @type {string}
     * @memberof DocumentoAccasamentoUpdateDTO
     */
    note?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DocumentoAccasamentoUpdateDTO
     */
    idFornitore?: number | null;
}

/**
 * Check if a given object implements the DocumentoAccasamentoUpdateDTO interface.
 */
export function instanceOfDocumentoAccasamentoUpdateDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DocumentoAccasamentoUpdateDTOFromJSON(json: any): DocumentoAccasamentoUpdateDTO {
    return DocumentoAccasamentoUpdateDTOFromJSONTyped(json, false);
}

export function DocumentoAccasamentoUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentoAccasamentoUpdateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idAnagrafeMittente': !exists(json, 'idAnagrafeMittente') ? undefined : json['idAnagrafeMittente'],
        'idAnagrafeDestinatario': !exists(json, 'idAnagrafeDestinatario') ? undefined : json['idAnagrafeDestinatario'],
        'dataDocumento': !exists(json, 'dataDocumento') ? undefined : (new Date(json['dataDocumento'])),
        'numeroDocumento': !exists(json, 'numeroDocumento') ? undefined : json['numeroDocumento'],
        'dataOperazione': !exists(json, 'dataOperazione') ? undefined : (new Date(json['dataOperazione'])),
        'note': !exists(json, 'note') ? undefined : json['note'],
        'idFornitore': !exists(json, 'idFornitore') ? undefined : json['idFornitore'],
    };
}

export function DocumentoAccasamentoUpdateDTOToJSON(value?: DocumentoAccasamentoUpdateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idAnagrafeMittente': value.idAnagrafeMittente,
        'idAnagrafeDestinatario': value.idAnagrafeDestinatario,
        'dataDocumento': value.dataDocumento === undefined ? undefined : (value.dataDocumento.toISOString()),
        'numeroDocumento': value.numeroDocumento,
        'dataOperazione': value.dataOperazione === undefined ? undefined : (value.dataOperazione.toISOString()),
        'note': value.note,
        'idFornitore': value.idFornitore,
    };
}

